import React from 'react'
import Button from '../DMGComponents/Button'
import { requestApproval, requestApproverChange } from '../fetchData';
import Break from '../DMGComponents/Break'
import toast, { Toaster } from 'react-hot-toast';
import { AreaContext } from './AreaContext';
import Input from '../DMGComponents/Input'
import ApprovalIcon from '../assets/img/approve.svg';

class AreaApproval extends React.Component {
    static contextType = AreaContext;

    constructor(props) {
        super(props);

        this.state = {
            area: this.props.area,
            showChangeApprover: false,
            changeApproverText: '',
        }

        this.requestApproval = this.requestApproval.bind(this);
    }   

    componentDidMount() {
        
    }

    requestApproval = () => {
        requestApproval(this.props.area.id).then((res) => {
            this.props.updateManagerApprovalRequestTimeUnixMs(res);
            toast.success("Approval requested");
        }).catch((err) => {
            toast.error("Error requesting approval");
            console.error("Error", err);
        })
    };

    openCloseChangeApprover = () => {
        this.setState({ showChangeApprover: !this.state.showChangeApprover });
    }

    requestApproverChange = () => {
        requestApproverChange(this.state.changeApproverText).then(() => {
            toast.success("Approver change requested");
            this.setState({ showChangeApprover: false, changeApproverText: '' });
        }).catch((err) => {
            toast.error("Error requesting approver change");
            console.error("Error", err);
        })
    }

    render() {
        const { areaUsersCount } = this.context;

        const dateOptions = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: '2-digit',
            minute: '2-digit'
        };

        return (
            <div style={{ ...this.props.style, textAlign: "left" }} className="fileExChildComponent">
                <Toaster />
                <Break style={{ margin: "20px 0" }}>
                    <div style={{ display: "flex" }}>
                        <div style={{ marginRight: "44px" }}>
                            <img
                                src={ApprovalIcon}
                                alt="Approval"
                                style={{ height: "2rem", position: "absolute" }}
                            />
                        </div>
                        <div>
                            Approval
                        </div>
                    </div>
                </Break>
               
                <div style={{ marginTop: "8px" }}> 
                    {this.props.area.status === 0 && this.props.approverDescription.length > 0 && this.props.area.managerApprovalRequestTimeUnixMs === 0 &&
                        <p>
                            Notifications to users will be sent after the area is approved by <b>{this.props.approverDescription}</b>.<br />
                            Approval is possible after adding at least one user.<br/>
                            Upon requesting approval the approver will be sent an email.<br />
                            After 24 hours a reminder is sent and later on the request will be forwarded to (a) fallback central approver(s).<br/>
                            If you wish to raise a ticket to change your approver, please use the "Change Approver" button to request a change.
                        </p>
                    }
                    {this.props.area.status === 0 && this.props.approverDescription.length === 0 &&
                        <p>
                            There is no approver set for your account. Please use the "Change Approver" button to request a change.<br/>
                            Only after approval by your approver users will get permission to use the area and get notified.<br />
                            Please come back when an approver is set for your account.
                        </p>
                    }
                    {this.props.area.status === 0 && this.props.area.managerApprovalRequestTimeUnixMs > 0 &&
                        <p>
                            Approval is pending and was requested at {new Date(this.props.area.managerApprovalRequestTimeUnixMs).toLocaleDateString(undefined, dateOptions)}.<br />
                            After 24 hours a reminder is sent to your approver <b>{this.props.approverDescription}</b> and later on the request will be forwarded to (a) fallback central approver(s).<br />
                        </p>
                    }
                </div>
                <div style={{ display: "flex", justifyContent: "right", marginBottom: "12px", marginTop: '8px' }}>
                    {this.props.area.status === 0 &&
                        <div style={{ marginRight: "12px" }}>
                            <Button type="hover-bottom-left" onClick={() => { this.openCloseChangeApprover() }}
                                disabled={this.props.area.managerApprovalRequestTimeUnixMs > 0}>
                                Change approver
                            </Button>
                        </div>
                    }
                    {this.props.area.status === 0 &&
                        <div>
                            <Button type="hover-bottom-left" onClick={() => { this.requestApproval() }}
                                disabled={this.props.approverDescription.length === 0 ||
                                    (areaUsersCount <= 1 && !this.props.area.isAdHoc) ||
                                    (areaUsersCount === 0 && this.props.area.isAdHoc) ||
                                    this.props.area.managerApprovalRequestTimeUnixMs > 0}
                            >
                                Request approval
                            </Button>
                        </div>
                    }
                </div>
                {this.state.showChangeApprover &&
                    <div style={{ display: "flex", marginBottom: "12px", marginTop: '8px' }}>
                        <div style={{ flex: 1, marginRight: "12px" }}>
                            <Input
                                label={this.state.changeApproverText.length < 4 && this.state.changeApproverText.length > 0 ? "Enter atleast 4 characters" : "New approver suggestion"}
                                value={this.state.changeApproverText}
                                onClick={e => { this.setState({ changeApproverText: e }) }}
                                style={{ width: "100%" }}
                            />
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <Button type="hover-bottom-left" onClick={() => { this.requestApproverChange() }}
                                disabled={this.state.changeApproverText.length <= 4}
                            >
                                Request approver change
                            </Button>
                        </div>
                    </div>
                }
                <hr style={{ margin: "30px 0" }} />
            </div>

        );
    }
}
export default AreaApproval;